<template>
    <backend-layout title="Developer Dashboard">
        <div className="grid gap-6 grid-cols-2 md:grid-cols-3 mb-6">
            <div className="md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">
                <div className="card-content">
                    <div className="flex items-center justify-between">
                        <div className="widget-label">
                            <h3>
                               Total Campaigns
                            </h3>
                            <h1>
                                {{ campaigns }}
                            </h1>
                        </div>
                        <span className="icon widget-icon text-green-500"><i
                            className="mdi mdi-newspaper-variant mdi-48px"></i></span>
                    </div>
                </div>
            </div>
            <div className="md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">
                <div className="card-content">
                    <div className="flex items-center justify-between">
                        <div className="widget-label">
                            <h3>
                                Total Influencers
                            </h3>
                            <h1>
                                {{ referrers }}
                            </h1>
                        </div>
                        <span className="icon widget-icon text-blue-500"><i
                            className="mdi mdi-link mdi-48px"></i></span>
                    </div>
                </div>
            </div>

            <div className="md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">
                <div className="card-content">
                    <div className="flex items-center justify-between">
                        <div className="widget-label">
                            <h3>
                                Total Users
                            </h3>
                            <h1>
                                {{ users }}
                            </h1>
                        </div>
                        <span className="icon widget-icon text-red-500"><i
                            className="mdi mdi-cursor-pointer mdi-48px"></i></span>
                    </div>
                </div>
            </div>
        </div>

    </backend-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Welcome from '@/Jetstream/Welcome.vue'
import BackendLayout from "@/Layouts/BackendLayout";

export default defineComponent({
    components: {
        BackendLayout,
        AppLayout,
        Welcome,
    },
    props: {
        campaigns: String,
        referrers: String,
        users: String
    }
})
</script>
